/* unplugin-vue-components disabled */import script from "./my-seaction-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./my-seaction-header.vue?vue&type=script&lang=ts&setup=true"

import "./my-seaction-header.vue?vue&type=style&index=0&id=9c993114&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c993114"]])

export default __exports__